"use strict";

define('model/agenda.message.template',['./message.template'], function (MessageTemplate) {
  var AgendaMessageTemplate = MessageTemplate.extend({
    validation: {
      recipients: {
        required: true
      }
    }
  });
  return AgendaMessageTemplate;
});

